// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2ORYa","buttons":"SendReceipts_buttons__3XH5O","email":"SendReceipts_email__1xrrA","bookApptTitle":"SendReceipts_bookApptTitle__Ss9ZS"};